export const ISM_PLACEMENT_KEY = 'ism';

const hasCategoryOrSubCategory = (subCategoryId, categoryId) =>
  !subCategoryId || categoryId === subCategoryId;

const hasInSortContent = ({ subCategoryId, categoryId, content }) =>
  hasCategoryOrSubCategory(subCategoryId, categoryId) &&
  Array.isArray(content) &&
  content.length > 0;

const getInsort = (categoryId, subCategoryId, category) =>
  category?.[categoryId]?.[subCategoryId]?.['in-sort'] ?? undefined;

const getInSortFilteringExcludedCids = (categoryId, divisionId, division) =>
  division?.[divisionId]?.['in-sort']?.filter(
    ({ excludedCids }) => !excludedCids?.includes(categoryId)
  ) ?? undefined;

const parseSubCategoryContentData = (categoryId, subCategoryId, category) => {
  if (!categoryId || !subCategoryId) return undefined;

  return getInsort(categoryId, subCategoryId, category);
};

const parseCategoryContentData = (categoryId, category) => {
  if (!categoryId) return undefined;

  return category?.[categoryId]?.['in-sort'] ?? undefined;
};

const parseDivisionContentData = (categoryId, divisionId, division) => {
  if (!divisionId || !categoryId) return undefined;

  return getInSortFilteringExcludedCids(categoryId, divisionId, division);
};

export function getIsmSizeFromAmplienceData(cmsData) {
  if (
    // eslint-disable-next-line no-underscore-dangle
    cmsData?._meta?.schema &&
    // eslint-disable-next-line no-underscore-dangle
    cmsData._meta.schema.indexOf('ism-double') >= 0
  ) {
    return {
      desktop: 2,
      mobile: 2,
    };
  }

  return {
    desktop: 1,
    mobile: 1,
  };
}

const getAmplianceResponse = (
  subCategoryId,
  categoryId,
  divisionId,
  contentData
) => {
  return [subCategoryId, categoryId, divisionId].reduce(
    (response, cid) => (
      // get an amplience response if one exists and if one hasn't been set already
      !response
        ? contentData[`${cid}/${ISM_PLACEMENT_KEY}`]?.contentItems
        : response,
      undefined
    )
  );
};

const mapAmplianceResponse = content => ({
  ...content,
  rowPosition: content.rowPosition || {
    desktop: 1,
    mobile: 1,
  },
  size: content.size || getIsmSizeFromAmplienceData(content),
});

const containsSubCatIsmContent = subcatISMContent =>
  subcatISMContent && subcatISMContent !== null;

const hasSubCategoryIsmContent = subcatISMContent => {
  if (containsSubCatIsmContent(subcatISMContent)) return subcatISMContent;
};

const hasCategoryOrDivisionContent = (
  subCategoryId,
  categoryId,
  categoryISMContent,
  divisionISMContent
) => {
  if (
    hasInSortContent({ subCategoryId, categoryId, content: categoryISMContent })
  ) {
    return categoryISMContent;
  }

  if (
    hasInSortContent({ subCategoryId, categoryId, content: divisionISMContent })
  ) {
    return divisionISMContent;
  }

  return null;
};

export const parseContentData = (contentData, contentDataIDs) => {
  const { categoryId, subCategoryId, divisionId } = contentDataIDs;
  const { category, division } = contentData;

  const amplienceResponse = getAmplianceResponse(
    subCategoryId,
    categoryId,
    divisionId,
    contentData
  );

  if (amplienceResponse) {
    return amplienceResponse.map(mapAmplianceResponse);
  }

  const subcatISMContent = parseSubCategoryContentData(
    categoryId,
    subCategoryId,
    category
  );
  const categoryISMContent = parseCategoryContentData(categoryId, category);
  const divisionISMContent = parseDivisionContentData(
    categoryId,
    divisionId,
    division
  );

  return (
    hasSubCategoryIsmContent(subcatISMContent) ||
    hasCategoryOrDivisionContent(
      subCategoryId,
      categoryId,
      categoryISMContent,
      divisionISMContent
    )
  );
};
